import type { Copy } from "../types";

export const sv: Copy = {
    seo: {
      title: "Bilålderskalkylator | Kontrollera fordonsålder efter år och månad",
      description:
        "Kontrollera ett fordons ålder från tillverkningsår och valfri månad. Se år, månader, dagar, totalt antal dagar och milstolpar.",
      keywords: [
        "bilålderskalkylator",
        "fordonsålderskalkylator",
        "tillverkningsår bil",
        "tillverkningsmånad fordon",
        "hur gammal är min bil",
        "bilålder efter år",
        "kontrollera fordonsålder",
        "RC ålderskalkylator",
        "bilålder efter månad",
        "fordonsdatum kalkylator",
        "mParivahan alternativ",
        "Parivahan alternativ",
        "RTO fordonsålderskalkylator",
        "kontrollera registreringsålder",
        "fordonets registreringsålder",
      ],
      faq: [
        {
          question: "Vad gör den här kalkylatorn?",
          answer:
            "Den beräknar exakt ålder för ett fordon från valt tillverkningsår och valfri månad och visar år, månader, dagar och milstolpar.",
        },
        {
          question: "Varför finns en valfri månad?",
          answer:
            "Månaden gör åldersberäkningen mer exakt. Om du hoppar över den använder appen januari i det valda året.",
        },
        {
          question: "Kan jag välja ett framtida år eller en framtida månad?",
          answer:
            "Nej. Framtida år blockeras och framtida månader inaktiveras när det valda året är innevarande år.",
        },
      ],
    },
    headerTagline: "Fordonsverktyg",
    headerTitle: "Bilålderskalkylator",
    reset: "Återställ",
    switchToLight: "Byt till ljust läge",
    switchToDark: "Byt till mörkt läge",
    languageLabel: "Språk",
    languageEnglish: "Engelska",
    languageHindi: "Hindi",
    heroEyebrow: "Bilålder, tydligt",
    heroTitle: "Ett enkelt datumverktyg för fordonsålder.",
    heroDescription:
      "Välj tillverkningsår. Lägg bara till månad om du vill ha ett mer exakt åldersresultat.",
    yearSelectLabel: "Tillverkningsår",
    monthSelectLabel: "Tillverkningsmånad",
    includeMonthLabel: "Ta med specifik månad för högre precision",
    includeMonthNote:
      "Om du inte tar med en månad används januari i beräkningen.",
    yearOnlyBadge: "Endast år",
    yearMonthBadge: "År + månad",
    yearPlaceholder: "Välj år",
    monthPlaceholder: "Välj månad",
    inputTitle: "Tillverkningsår",
    inputLabel: "Tillverkningsår",
    blockedDateNote: "Framtida år är blockerade.",
    result: "Resultat",
    vehicleAgeLead: "Ditt fordon är",
    asOfToday: "Per idag",
    years: "År",
    months: "Månader",
    days: "Dagar",
    totalDays: (count) => `${count.toLocaleString("sv-SE")} dagar totalt`,
    ageLabels: {
      almostNew: "Nästan nytt",
      modern: "Modernt",
      mature: "Vuxet",
      classic: "Klassiskt",
    },
    estimatedValue: {
      high: "Hög återförsäljningspotential",
      healthy: "God värdehållning",
      moderate: "Måttlig värdeminskning",
      collector: "Samlarintresset kan öka",
    },
    maintenanceTitle: "Underhåll",
    maintenance: {
      routine: "Rutinfservice och OEM-underhåll",
      watch: "Håll koll på bromsar, vätskor och däck",
      plan: "Planera slitdelar och inspektioner",
      specialized: "Specialiserat underhåll blir värdefullt",
    },
    registrationTitle: "Registrering",
    registration: {
      collector: "Kan kvalificera för samlarfordonsliknande hantering i vissa regioner",
      classic: "Klassisk fordonsregistrering kan gälla i vissa regioner",
      standard: "Räkna med standardförnyelser och regionala kontroller",
      regular: "Vanlig registrering gäller oftast",
    },
    upcomingMilestoneTitle: "Kommande milstolpe",
    milestoneTimelineTitle: "Milstolpar",
    milestoneRemaining: ({ label, days }) => `${label} om ${days.toLocaleString("sv-SE")} dagar`,
    reached: "Uppnådd",
    upcoming: "Kommande",
    allMilestonesReachedTitle: "Alla listade milstolpar är uppnådda",
    allMilestonesReachedBody:
      "Detta fordon har passerat intervallet för milstolpar som visas i appen.",
    copySummary: "Kopiera sammanfattning",
    shareResult: "Dela resultat",
    resetMessage: "Kalkylatorn återställd",
    summaryCopied: "Sammanfattning kopierad till urklipp",
    clipboardFailed: "Åtkomst till urklipp misslyckades",
    emptyTitle: "Välj ett tillverkningsår för att se hela uppdelningen",
    emptyDescription:
      "När ett år har valts visas exakt ålder, totalt antal dagar, underhållsnoteringar, klassikerstatus och milstolpar.",
    shareTitle: "Bilålderskalkylator",
    summary: ({ label, years, months, days, asOf }) =>
      `Min bil tillverkades i ${label} och är ${years} år, ${months} månader och ${days} dagar gammal per ${asOf}.`,
    milestones: {
      1: { label: "Första året", note: "Användbart för garanti- och serviceplanering." },
      3: { label: "Tre år", note: "En vanlig punkt för andrahandsvärde och värdeförändringar." },
      5: { label: "Fem år", note: "Bra tidpunkt för djupare underhållsbudgetering." },
      10: { label: "Tio år", note: "Åldrande komponenter behöver extra uppmärksamhet." },
      15: { label: "Femton år", note: "Många regioner börjar behandla fordon som klassiska här." },
      25: { label: "Tjugofem år", note: "Samlar- och importintresse kan öka på vissa marknader." },
    },
  };
